export const Specs = {
  OPEN_IN_NEW_TAB_BM: 'specs.premium.SplitPageInNewTabForIframe_BM',
  WIX_VIBE_OPEN_IN_NEW_TAB: 'specs.premium.domains.WixVibeOpenInNewTab',
  UPGRADE_PAYWALL_BM: 'specs.premium.domains.DomainsUpgradePaywallBM'
};
//# sourceMappingURL=Specs.js.map